import i18n from 'i18next';
import {
    detectors,
    fallbackLng,
    interpolation,
    detection,
} from '@tencent/docs-scenario-components-language-pack';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import zhAll from './i18n/zh/translation.json';
import enAll from './i18n/en/translation.json';
import hkAll from './i18n/zh-HK/translation.json';
import userLocalStorage, { LocalStorageKeys } from '@src/slide/infrastructure/module/independent/local-storage';


const resources = {
    'zh-CN': {
        translation: {
            ...zhAll,
        },
    },
    en: {
        translation: {
            ...enAll,
        },
    },
    'zh-HK': {
        translation: {
            ...hkAll,
        },
    },
};

// 国际化初始化
i18n
    .use(detectors)
    .init({
        debug: false,
        resources,
        fallbackLng,
        interpolation,
        detection,
    });

i18n.on('languageChanged', (lng) => {
    if (userLocalStorage.getItem(LocalStorageKeys.I18NLAN) !== lng) {
        userLocalStorage.setItem(LocalStorageKeys.I18NLAN, lng);
    }
});

if (!ENV.IS_RELEASE) {
    global.changeLan = (lan) => {
        if (lan === 'zh') {
            i18n.changeLanguage('zh');
        }
        if (lan === 'en') {
            i18n.changeLanguage('en');
        }
    };
}

export default i18n;

